/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { extractErrorKeyAndMessage } from '@/auth/lib/extractErrorKeyAndMessage';
import { FormSlotProps } from '@/auth/types';
import { useText } from 'preact-i18n';
import { Slot } from '@adobe-commerce/elsie/lib';

export const FormSlot = ({
  slots,
  item,
  handleOnChange,
  handleOnBlur,
  handleOnFocus,
  errorConfig,
  errors,
}: FormSlotProps) => {
  const { errorKey, defaultErrorMessage } =
    extractErrorKeyAndMessage(errorConfig);
  const customErrorMessage = useText(`Auth.FormText.${errorKey}.${item.code}`)[
    item.code
  ];

  let errorMessage = '';

  // This check indicates that validation identified an error
  if (defaultErrorMessage.length) {
    errorMessage = customErrorMessage || defaultErrorMessage;
  }

  const contextValue = {
    inputName: item.customUpperCode,
    handleOnChange,
    handleOnBlur,
    handleOnFocus,
    errorMessage,
    errors,
    config: item,
  };

  return (
    <Slot
      data-testid={`signUpFormInput_${item.code}`}
      name={`SignUpFormInput_${item.code}`}
      slot={slots?.[`SignUpFormInput_${item.code}`]}
      context={contextValue}
      key={item.id}
    />
  );
};
